import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaCheckCircle, FaUser } from 'react-icons/fa';
import PageHero from '../components/PageHero';

const init = { name:'', email:'', company:'', phone:'', service:'', message:'' };
const svcs  = ['Design Services','EMS Solutions','PCB Assembly','Cable Harness','Box Build Assembly','NPI / Prototyping','General Inquiry'];

function validate(f) {
  const e = {};
  if (!f.name.trim())    e.name    = 'Full name is required.';
  if (!f.email.trim())   e.email   = 'Email is required.';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) e.email = 'Enter a valid email.';
  if (!f.service)        e.service = 'Please select a service.';
  if (!f.message.trim()) e.message = 'Please describe your requirements.';
  return e;
}

export default function Contact() {
  const [form, setForm]     = useState(init);
  const [errors, setErrors] = useState({});
  const [done, setDone]     = useState(false);
  const [busy, setBusy]     = useState(false);
  const [apiError, setApiError] = useState('');

  const onChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(er => ({ ...er, [name]: '' }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setBusy(true);
    setApiError('');

    const payload = {
      fullName:            form.name,
      emailAddress:        form.email,
      company:             form.company,
      phoneNumber:         form.phone,
      serviceRequired:     [form.service],
      projectRequirements: form.message,
    };

    try {
      const res = await fetch('https://vvs-school-api.consolewaves.com/api/v1/mail/saalfo-contact', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(payload),
      });

      if (!res.ok) {
        let msg = `Server error (${res.status})`;
        try {
          const data = await res.json();
          msg = data?.message || data?.error || msg;
        } catch (_) {}
        throw new Error(msg);
      }

      setDone(true);
    } catch (err) {
      setApiError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  const fi = (field) => ({
    width:'100%', padding:'11px 14px',
    border:`1.5px solid ${errors[field] ? '#ef4444' : '#e2e8f0'}`,
    borderRadius:8, fontSize:14, fontFamily:'Inter',
    color:'#1a1a2e', background:'#fff', outline:'none',
  });

  return (
    <div>
      <PageHero
        chip="Contact Us"
        title="Let's Build Something Great Together"
        subtitle="Share your project requirements — our team will respond within 24 business hours with a tailored proposal."
      />

      <section className="sec">
        <div
          className="wrap"
          style={{ width:'100%', maxWidth:'100%', padding:'0 24px' }}
        >
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1.7fr', gap:48, alignItems:'start' }} className="contact-grid">

            {/* ── Left info ── */}
            <div>
              <h2 className="h2" style={{ marginBottom:8 }}>Get in Touch</h2>
              <p style={{ color:'#64748b', fontSize:14, lineHeight:1.75, marginBottom:28 }}>
                Whether you're at design stage or ready for production, the Saalfo Tech team is here to help.
              </p>

              <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:28 }}>
                {[
                  { icon:<FaEnvelope size={14}/>, label:'Email',    value:'info@saalfo.com',          href:'mailto:info@saalfo.com' },
                  { icon:<FaPhone size={14}/>,   label:'Phone',    value:'+91 6363674212',            href:'tel:+916363674212' },
                  { icon:<FaMapMarkerAlt size={14}/>, label:'Location', value:'Mysore, Karnataka, India', href:null },
                ].map((c,i) => (
                  <div key={i} style={{ display:'flex', gap:12, padding:'13px 16px', borderRadius:10,
                    border:'1px solid #e2e8f0', background:'#f8fafb' }}>
                    <div style={{ width:34, height:34, borderRadius:8, background:'#eaf6ea',
                      display:'flex', alignItems:'center', justifyContent:'center', color:'#3d8b3d', flexShrink:0 }}>
                      {c.icon}
                    </div>
                    <div>
                      <p style={{ fontSize:11, fontWeight:600, color:'#94a3b8', letterSpacing:'.08em', textTransform:'uppercase', marginBottom:2 }}>{c.label}</p>
                      {c.href
                        ? <a href={c.href} style={{ fontSize:14, color:'#1a1a2e', textDecoration:'none', fontWeight:500 }}>{c.value}</a>
                        : <span style={{ fontSize:14, color:'#1a1a2e', fontWeight:500 }}>{c.value}</span>
                      }
                    </div>
                  </div>
                ))}
              </div>

              {/* BD contact */}
              <div className="card" style={{ borderLeft:'4px solid #5cb85c', padding:'20px 22px', marginBottom:16 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                  <div style={{ width:36, height:36, borderRadius:50, background:'#eaf6ea', display:'flex', alignItems:'center', justifyContent:'center', color:'#3d8b3d' }}>
                    <FaUser size={15}/>
                  </div>
                  <div>
                    <p style={{ fontSize:15, fontWeight:700, color:'#1a1a2e', fontFamily:'Rajdhani' }}>Ayaz Ahmed</p>
                    <p style={{ fontSize:12, color:'#64748b' }}>Sr. Engineer — Business Development & PM</p>
                  </div>
                </div>
                <a href="mailto:info@saalfo.com" style={{ fontSize:13, color:'#3d8b3d', textDecoration:'none', display:'block', marginBottom:3 }}>
                  info@saalfo.com
                </a>
                <a href="tel:+916363674212" style={{ fontSize:13, color:'#3d8b3d', textDecoration:'none' }}>
                  +91 6363674212
                </a>
              </div>

              <div style={{ padding:'16px 18px', borderRadius:10, background:'#eaf6ea', border:'1px solid #c3e6c3' }}>
                <p style={{ fontSize:13, fontWeight:700, color:'#166534', marginBottom:3 }}>⚡ Quick Response Guarantee</p>
                <p style={{ fontSize:13, color:'#15803d' }}>We respond to all enquiries within 24 business hours.</p>
              </div>
            </div>

            {/* ── Right form ── */}
            <div>
              {done ? (
                <div style={{ textAlign:'center', padding:'60px 40px', border:'1px solid #c3e6c3',
                  borderRadius:16, background:'#f0faf0' }}>
                  <FaCheckCircle size={52} style={{ color:'#5cb85c', marginBottom:20 }}/>
                  <h3 style={{ fontFamily:'Rajdhani', fontSize:28, fontWeight:700, color:'#1a1a2e', marginBottom:8 }}>
                    Message Received!
                  </h3>
                  <p style={{ color:'#4a5568', marginBottom:28 }}>
                    Thank you for reaching out. Our team will reply within 24 hours.
                  </p>
                  <button className="btn btn-outline" onClick={() => { setDone(false); setForm(init); setApiError(''); }}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form onSubmit={onSubmit} noValidate
                  style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:16,
                    padding:'36px 32px', boxShadow:'0 4px 24px rgba(0,0,0,0.06)' }}>
                  <h3 style={{ fontFamily:'Rajdhani', fontSize:22, fontWeight:700, color:'#1a1a2e', marginBottom:24 }}>
                    Tell Us About Your Project
                  </h3>

                  <div className="g2" style={{ marginBottom:16 }}>
                    {[
                      { name:'name',    label:'Full Name *',      ph:'John Smith',          type:'text' },
                      { name:'email',   label:'Email Address *',  ph:'john@company.com',    type:'email' },
                      { name:'company', label:'Company',          ph:'Your Company Ltd.',   type:'text' },
                      { name:'phone',   label:'Phone Number',     ph:'+91 XXXXX XXXXX',     type:'tel' },
                    ].map(f => (
                      <div key={f.name}>
                        <label className="fl">{f.label}</label>
                        <input type={f.type} name={f.name} value={form[f.name]}
                          onChange={onChange} placeholder={f.ph} style={fi(f.name)}/>
                        {errors[f.name] && <p className="fe">{errors[f.name]}</p>}
                      </div>
                    ))}
                  </div>

                  <div style={{ marginBottom:16 }}>
                    <label className="fl">Service Required *</label>
                    <select name="service" value={form.service} onChange={onChange}
                      style={{ ...fi('service'), background:'#fff' }}>
                      <option value="">Select a service…</option>
                      {svcs.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                    {errors.service && <p className="fe">{errors.service}</p>}
                  </div>

                  <div style={{ marginBottom:24 }}>
                    <label className="fl">Project Requirements *</label>
                    <textarea name="message" value={form.message} onChange={onChange} rows={5}
                      placeholder="Describe your project — product type, volumes, timeline, certifications needed…"
                      style={{ ...fi('message'), resize:'vertical' }}/>
                    {errors.message && <p className="fe">{errors.message}</p>}
                  </div>

                  {apiError && (
                    <div style={{ marginBottom:16, padding:'12px 16px', borderRadius:8,
                      background:'#fef2f2', border:'1px solid #fecaca', color:'#dc2626', fontSize:13 }}>
                      ⚠️ {apiError}
                    </div>
                  )}

                  <button type="submit" className="btn btn-primary" disabled={busy}
                    style={{ width:'100%', justifyContent:'center', fontSize:15, padding:'13px 24px' }}>
                    {busy ? (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                          style={{ animation:'spin .8s linear infinite' }}>
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3"
                            strokeDasharray="31.4" strokeDashoffset="10" strokeLinecap="round"/>
                        </svg>
                        Sending…
                      </>
                    ) : 'Send Message'}
                  </button>
                  <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
                </form>
              )}
            </div>
          </div>
        </div>
        <style>{`@media(max-width:768px){.contact-grid{grid-template-columns:1fr!important}}`}</style>
      </section>

      {/* ── Full-width Map Section ── */}
      <section style={{ padding:'0 24px 64px' }}>
        <div style={{ maxWidth:'100%' }}>
          <div style={{
            display:'flex', alignItems:'center', justifyContent:'space-between',
            marginBottom:16, flexWrap:'wrap', gap:12
          }}>
            <h3 style={{ fontFamily:'Rajdhani', fontSize:22, fontWeight:700, color:'#1a1a2e', margin:0 }}>
              Our Location
            </h3>
            <a
              href="https://www.google.com/maps/place/Saalfo+Tech+Pvt+Ltd/@12.3558876,76.6354054,17z"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize:13, fontWeight:600, color:'#3d8b3d',
                textDecoration:'none', display:'flex', alignItems:'center', gap:6,
                padding:'8px 16px', borderRadius:8,
                border:'1px solid #c3e6c3', background:'#eaf6ea'
              }}
            >
              <FaMapMarkerAlt size={13}/> Get Directions →
            </a>
          </div>
          <iframe
            title="Saalfo Tech Pvt Ltd Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3938.234!2d76.6354054!3d12.3558876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baf7a0e91357d7b%3A0x63547d28ef8bd467!2sSaalfo%20Tech%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{
              border:0, borderRadius:12, display:'block',
              boxShadow:'0 4px 24px rgba(0,0,0,0.08)'
            }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>
    </div>
  );
}